import { Component, inject, input, signal } from '@angular/core';
import { LanguageService } from '../../../../../services/language.service';

@Component({
  selector: 'app-image-side',
  imports: [],
  templateUrl: './image-side.html',
  styleUrl: './image-side.scss',
})
export class ImageSide {
  imageSrc = input.required<string>();
  title = input.required<string>();
  description = input.required<string>();
  type = input.required<'register' | 'login'>();

  private languageService = inject(LanguageService);
  currentLocale = signal<string>('en');

  toggleLanguage() {
    this.languageService.toggleLocale();
  }
  ngOnInit() {
    this.currentLocale.set(this.languageService.getCurrentLocale());
  }
}
